import * as yup from "yup";
import { getApiErrorMessage } from "./apiErrors";

// Staff PIN rules. The API accepts exactly 6 digits (`^\d{6}$` on
// POST /api/users/{uuid}/pin), so the form must enforce and announce the same.
export const PIN_LENGTH = 6;

const MESSAGES = {
  required: "Veuillez saisir le code PIN",
  digitsOnly: "Le code PIN ne doit contenir que des chiffres",
  length: `Le code PIN doit contenir exactement ${PIN_LENGTH} chiffres`,
  forbidden: "Vous n'êtes pas autorisé à définir le code PIN de cet utilisateur",
  generic: "Une erreur est survenue",
};

export const pinSchema = yup.object().shape({
  pin: yup
    .string()
    .required(MESSAGES.required)
    .matches(/^\d+$/, MESSAGES.digitsOnly)
    .length(PIN_LENGTH, MESSAGES.length),
});

// French messages for the translation keys the PIN endpoint returns. Other
// keys use the shared map (`src/lib/apiErrors.ts`).
const PIN_ERROR_MESSAGES: Record<string, string> = {
  "validation.user.error.pin.invalid_format": MESSAGES.length,
  "validation.user.error.pin.not_blank": MESSAGES.required,
  "security.access_denied": MESSAGES.forbidden,
};

// Turns a failed POST /users/{uuid}/pin into a French message. Never returns a
// raw translation key or the server's English text.
export function getPinErrorMessage(error: unknown): string {
  return getApiErrorMessage(error, MESSAGES.generic, {
    messages: PIN_ERROR_MESSAGES,
    forbidden: MESSAGES.forbidden,
  });
}
